// extracted by mini-css-extract-plugin
export default {"Input":"AlgoliaSearchInput_Input__nbI4s"};